import { db } from "@/api/db/db.index";
import {
  createMarketingConsentCookie,
  readServerMarketingConsent,
} from "@/api/lib/marketing-consent";
import { createServerFn } from "@tanstack/react-start";
import {
  getRequestHeaders,
  setResponseHeader,
} from "@tanstack/react-start/server";
import { coachingApplications, marketingEvents, payments } from "@thecoach/db";
import { and, eq } from "drizzle-orm";
import { z } from "zod";

export const getMarketingConsentFn = createServerFn({ method: "GET" }).handler(
  async () => {
    const headers = getRequestHeaders();
    const serverConsent = readServerMarketingConsent(headers);
    return {
      consent:
        serverConsent?.granted === true
          ? ("granted" as const)
          : serverConsent
            ? ("denied" as const)
            : null,
    };
  },
);

export const saveMarketingConsentFn = createServerFn({ method: "POST" })
  .inputValidator(z.object({ consent: z.enum(["granted", "denied"]) }))
  .handler(async ({ data }) => {
    const headers = getRequestHeaders();
    const previous = readServerMarketingConsent(headers);
    const id = previous?.id || crypto.randomUUID();

    if (data.consent === "denied") {
      await db
        .update(payments)
        .set({ marketingConsentGranted: false })
        .where(eq(payments.marketingConsentId, id));
      await db
        .update(coachingApplications)
        .set({ marketingConsentGranted: false })
        .where(eq(coachingApplications.marketingConsentId, id));
      await db
        .update(marketingEvents)
        .set({ status: "cancelled" })
        .where(
          and(
            eq(marketingEvents.consentId, id),
            eq(marketingEvents.status, "pending"),
          ),
        );
    }

    const isSecure =
      headers.get("x-forwarded-proto") === "https" ||
      process.env.NODE_ENV === "production";

    setResponseHeader(
      "Set-Cookie",
      createMarketingConsentCookie(
        { id, granted: data.consent === "granted" },
        isSecure,
      ),
    );

    return { success: true, consent: data.consent };
  });
